import { ChangeDetectionStrategy, Component, effect, signal } from "@angular/core";
import { ModalComponent } from "../../modules/modal/modal.component";
import { ModalHeaderComponent } from "../../modules/modal/modal.header.component";
import { ModalCloseButtonComponent } from "../../modules/modal/modal.close.button.component";
import { S25ModalModule } from "../../modules/s25-modal/s25.modal.module";

@Component({
    selector: "s25-ng-copyright-modal",
    template: `
        <s25-modal-header [data]="params()">
            <h4 class="modal-title">
                <span>Copyright ©{{ currentYear() }} CollegeNET, Inc. All rights reserved.</span>
            </h4>
            <div class="modal-header-flex">
                <modal-close-button (close)="params()?.closeModal()" />
            </div>
        </s25-modal-header>
        <div class="modal-body">
            <div class="copyrightText c-margin-bottom--single">
                <p>
                    This product is furnished under license and may be used only in accordance with the terms of such
                    license.
                </p>
                <br />
                <p>
                    Information in the online help is subject to change without notice. Although many precautions were
                    taken in the preparation of this product, CollegeNET, Inc. assumes no responsibility for errors or
                    omissions.
                </p>
                <br />
                <p>
                    Unless otherwise noted, any organization, product, person, or event depicted in an example herein is
                    fictitious, and no association with any real organization, product, person, or event is intended or
                    should be inferred.
                </p>
                <br />
                <p>
                    CollegeNET, 25Live, R25, X25, Schedule25, and Series25 are registered trademarks of CollegeNET, Inc.
                </p>
            </div>
        </div>
        <s25-ng-modal-footer [type]="'close'" (affirm)="params()?.closeModal()" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalHeaderComponent, ModalCloseButtonComponent, S25ModalModule],
})
export class CopyrightModalComponent extends ModalComponent {
    static readonly size = "lg";

    readonly currentYear = signal(new Date().getFullYear());

    constructor() {
        super();
        effect((onCleanup) => {
            const now = new Date();
            const msUntilNextYear = new Date(now.getFullYear() + 1, 0, 1).getTime() - now.getTime();
            const id = setTimeout(() => this.currentYear.set(new Date().getFullYear()), msUntilNextYear);
            onCleanup(() => clearTimeout(id));
        });
    }
}
